<template>
  <div class="bloc" style="padding:5px; font-size:14px;">
    <div style="float:right;display:flex">
      <AddSectionQuestionButton
        v-if="!this.$store.getters.showTreeComponent"
        :entitledSurvey="$store.getters.configure_questions_sondage_name"
      />
      <ButtonTreeSections
        v-if="this.$store.state.question.sections.length > 1"
      />
      <ButtonAllFolding
        style="margin-right:10px;"
        v-if="!this.$store.getters.showTreeComponent"
      />
    </div>
    <div class="color-primary">
      {{ this.$store.state.sondage.configure_questions_sondage_name }}
    </div>
  </div>
</template>

<script>
import AddSectionQuestionButton from '@/components/question/components/AddSectionQuestionButton'
import ButtonAllFolding from '@/components/question/components/ButtonAllFolding'
import ButtonTreeSections from '@/components/question/components/ButtonTreeSections'
export default {
  name: 'ListButtons',
  components: {
    AddSectionQuestionButton,
    ButtonTreeSections,
    ButtonAllFolding
  }
}
</script>

<style scoped>
#title-sondage {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ListButtons.vue